import {Storage} from "@/services/Storage"
import store from '../store'

export const authentication = {
    hasUsers() {
        return Storage.getAllUsers().then(users => {
            if (!!users) {
                store.commit('setAllUsers', users);
            }
            return !!users;
        }).catch(() => false);
    },

    isAdminLoggedIn: async () => {
        let adminUser = await Storage.getAdminUser();
        return !!adminUser;
    },

    isStoreSelected() {
        return Storage.getDefaultStore().then((defaultStore) => {
            if (defaultStore) {
                store.commit('setDefaultStore', defaultStore)
            }
            return !!defaultStore;
        }).catch(() => false)
    },

    async isCurrentUserAdmin() {
        let user = await Storage.getCurrentUser();
        return user.Type.toLowerCase() === 'admin';
    }
}
